export function TrashIcon() {
  return (
    <span className="trash-icon" aria-hidden="true">
      <svg
        viewBox="0 0 24 24"
        width="20"
        height="20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <linearGradient id="canBody" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor="#6b7b86" />
            <stop offset="0.5" stopColor="#4a5763" />
            <stop offset="1" stopColor="#2f3942" />
          </linearGradient>
          <linearGradient id="canLid" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor="#8a99a3" />
            <stop offset="1" stopColor="#4a5763" />
          </linearGradient>
        </defs>

        {/* fly */}
        <g className="trash-fly">
          <circle cx="19" cy="4.5" r="0.7" fill="#1f2937" />
          <path d="M18.2 4 L17.2 3.5 M19.8 4 L20.8 3.5" stroke="#6b7b86" strokeWidth="0.4" strokeLinecap="round" />
        </g>

        {/* stink waves */}
        <path
          className="trash-stink"
          d="M7.5 4.5 C7.5 3.8 8.2 3.8 8.2 4.5 S8.9 5.2 8.9 4.5"
          stroke="#8bc27a"
          strokeWidth="0.6"
          fill="none"
          strokeLinecap="round"
          opacity="0.8"
        />
        <path
          className="trash-stink trash-stink-2"
          d="M14 3.5 C14 2.8 14.7 2.8 14.7 3.5 S15.4 4.2 15.4 3.5"
          stroke="#8bc27a"
          strokeWidth="0.6"
          fill="none"
          strokeLinecap="round"
          opacity="0.6"
        />

        {/* lid tilted */}
        <g transform="rotate(-6 12 7)">
          <rect x="3.2" y="5.8" width="17.6" height="2.4" rx="1.2" fill="url(#canLid)" stroke="#1f2937" strokeWidth="0.5" />
          <rect x="10.5" y="4.6" width="3" height="1.4" rx="0.6" fill="#6b7b86" stroke="#1f2937" strokeWidth="0.4" />
        </g>

        {/* can body with dent */}
        <path
          d="M4.5 9 L5.5 21 Q5.6 22 6.6 22 L17.4 22 Q18.4 22 18.5 21 L19.5 9 Z"
          fill="url(#canBody)"
          stroke="#1f2937"
          strokeWidth="0.6"
          strokeLinejoin="round"
        />

        {/* dent shading */}
        <path
          d="M8 13 Q9.5 14.5 8.5 16.5"
          stroke="#1f2937"
          strokeWidth="0.5"
          fill="none"
          opacity="0.6"
        />
        <path
          d="M15 11 Q14 12 15 13.5"
          stroke="#1f2937"
          strokeWidth="0.4"
          fill="none"
          opacity="0.5"
        />

        {/* vertical ridges */}
        <line x1="9" y1="10" x2="9.6" y2="21" stroke="#1f2937" strokeWidth="0.3" opacity="0.35" />
        <line x1="12" y1="10" x2="12" y2="21" stroke="#1f2937" strokeWidth="0.3" opacity="0.35" />
        <line x1="15" y1="10" x2="14.4" y2="21" stroke="#1f2937" strokeWidth="0.3" opacity="0.35" />

        {/* googly eyes peeking over rim */}
        <g className="trash-eyes">
          <circle cx="9.5" cy="10.2" r="1.4" fill="#fef9e7" stroke="#1f2937" strokeWidth="0.4" />
          <circle cx="14.2" cy="10.1" r="1.4" fill="#fef9e7" stroke="#1f2937" strokeWidth="0.4" />
          <circle className="trash-pupil trash-pupil-l" cx="9.8" cy="10.4" r="0.55" fill="#1f2937" />
          <circle className="trash-pupil trash-pupil-r" cx="14.5" cy="10.3" r="0.55" fill="#1f2937" />
        </g>
      </svg>
    </span>
  );
}
